import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import DOMPurify from 'dompurify';
import Plus from 'UI/IconsSrc/plus';
import Minus from 'UI/IconsSrc/minus';
var Expandable = /*#__PURE__*/function (_Component) {
  function Expandable(props) {
    var _this;
    _classCallCheck(this, Expandable);
    _this = _callSuper(this, Expandable, [props]);
    _defineProperty(_this, "onPress", function (event) {
      event.preventDefault();
      if (_this.props.onClick && typeof _this.props.onClick == 'function') {
        _this.props.onClick(_this.toggleOpen);
        return true;
      }
      _this.toggleOpen();
    });
    _defineProperty(_this, "onPlusPress", function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (_this.props.onPlus && typeof _this.props.onPlus == 'function') {
        _this.props.onPlus(_this.toggleOpen);
        return true;
      } else {
        if (_this.props.onClick && typeof _this.props.onClick == 'function') {
          _this.onPress(event);
          return true;
        }
      }
      _this.toggleOpen();
    });
    _defineProperty(_this, "toggleOpen", function (isOpen) {
      if (typeof isOpen != 'undefined' && isOpen != null) {
        _this.setState({
          open: isOpen
        });
      } else {
        _this.setState({
          open: !_this.state.open
        });
      }
      if (_this.props.onChange && typeof _this.props.onChange == 'function') {
        _this.props.onChange(isOpen ? isOpen : !_this.state.open);
      }
    });
    _defineProperty(_this, "getContentClassNames", function () {
      var className = 'expandable-content';
      var open = _this.state.open;
      var centerContent = _this.props.centerContent;
      var whiteBackground = _this.props.whiteBackground;
      if (open) {
        className += ' open';
      }
      if (centerContent) {
        className += ' centerContent';
      }
      if (whiteBackground) {
        className += ' expandable-white-bg';
      }
      return className;
    });
    _defineProperty(_this, "getHeaderClassNames", function () {
      var className = 'expandable-header';
      var open = _this.state.open;
      var color = _this.props.color;
      if (open) {
        className += ' open';
      }
      if (color) {
        className += ' has-color';
      }
      return className;
    });
    _this.state = {
      open: props.open || false
    };
    return _this;
  }
  _inherits(Expandable, _Component);
  return _createClass(Expandable, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps && nextProps.open != null) {
        if (nextProps.open != this.state.open) {
          this.toggleOpen(nextProps.open);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        title = _this$props.title,
        color = _this$props.color,
        html = _this$props.html,
        headerStyles = _this$props.headerStyles,
        contentStyles = _this$props.contentStyles,
        contentStylesClosed = _this$props.contentStylesClosed;
      var open = this.state.open;
      var style = typeof color !== 'undefined' ? {
        borderLeftColor: color
      } : {};
      return /*#__PURE__*/React.createElement("div", {
        className: "expandable-container",
        key: title
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getHeaderClassNames(),
        style: _objectSpread(_objectSpread({}, headerStyles), style)
      }, this.props.index ? /*#__PURE__*/React.createElement("span", null, this.props.index, "\xA0") : null, /*#__PURE__*/React.createElement("span", {
        onClick: this.onPress,
        className: "title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "trigger-container",
        onClick: this.onPlusPress
      }, /*#__PURE__*/React.createElement("span", {
        className: "trigger"
      }, open ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null)))), html != null ? /*#__PURE__*/React.createElement("div", {
        className: this.getContentClassNames(),
        style: open ? contentStyles : contentStylesClosed,
        dangerouslySetInnerHTML: {
          __html: children
        }
      }) : /*#__PURE__*/React.createElement("div", {
        className: this.getContentClassNames(),
        style: open ? contentStyles : contentStylesClosed
      }, children));
    }
  }]);
}(Component);
_defineProperty(Expandable, "defaultProps", {
  title: 'Visa mer',
  children: '',
  centerContent: false
});
export default Expandable;